const initialState = {
    count: 0,
}
export default (state = initialState, { type, payload }) => {

   
    switch (type) {
        case 'INCREMENT_COUNT':
            return { count: state.count + 1 };
        case 'DECREMENT_COUNT':
            return { count: state.count - 1 };
        default:
            return state;
    }
};